import { render, staticRenderFns } from "./PerformerSnippet.vue?vue&type=template&id=108299fc&"
import script from "./PerformerSnippet.vue?vue&type=script&lang=js&"
export * from "./PerformerSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports